import React, { Component } from 'react'

import { connect } from 'react-redux'
import {
  extractFilterOptions,
  clearFilterOptionValues,
  clearInputForm,
  updateFilterOptions,
  updateFormOptions,
  checkValidity,
  updateObject,
  updateFormData,
  extractFormData
} from '../../../../helpers/utils'
import * as actions from '../../../../store/actions'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'
import Alert from '../../../../components/Alert/Alert'
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal'
import FilterModal from '../../../../components/FilterModal/FilterModal'
import CorporateContent from '../../../../components/PageContent/Assignment/CorporateContent/CorporateContent'
import CopyModal from '../../../../components/PageContent/Assignment/CommonContent/CopyModal/CopyModal'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'
import ImportModal from '../../../../components/ImportModal/ImportModal'
import ActionModal from '../../Appraisal/AppraisalPage/ActionModal/ActionModal'
import moment from 'moment'

// Adding/Editing in this page will not render an edit modal.
// Instead, we will render an add/edit page

class Corporate extends Component {
  state = {
    appraisalTypeCode: 'APT01',
    assignmentType: null,
    selectedOrgs: [],
    selectedResults: [],
    // Copy modal state
    copyResultId: null,
    copyModalOpen: false,
    copyForm: {
      form_id: {
        label: this.props.translate('form'),
        elementType: 'newselect',
        elementConfig: {
          placeholder: 'Select Form',
          options: []
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      level_group_id: {
        label: this.props.translate('level'),
        elementType: 'newselect',
        elementConfig: {
          placeholder: 'Select Level',
          options: []
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      orgs: {
        label: this.props.translate('organization'),
        elementType: 'newmultiSelect',
        elementConfig: {
          placeholder: 'Select Organization',
          options: []
        },
        value: [],
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      }
    },
    // Delete modal state
    deleteOrgId: null,
    confirmationModalOpen: false,
    bulkConfirmationModalOpen: false,
    // Filter modal state
    filterModalOpen: false,
    filterControls: {
      company_id: {
        label: this.props.translate('company'),
        value: '',
        configs: {
          placeholder: 'Select Company',
          options: []
        },
        required: true
      },
      form_id: {
        label: this.props.translate('form'),
        value: '',
        configs: {
          placeholder: 'Select Form',
          options: []
        },
        required: true
      },
      structure_id: {
        label: this.props.translate('structure'),
        value: '',
        configs: {
          placeholder: 'Select Structure',
          options: []
        }
      },
      status_id: {
        label: this.props.translate('status'),
        value: '',
        configs: {
          placeholder: 'Select Status',
          options: []
        },
        required: false
      },
      level_group_id: {
        label: this.props.translate('levelGroup'),
        value: '',
        configs: {
          placeholder: 'Select Level',
          options: []
        },
        required: false
      },
      org_id: {
        label: this.props.translate('organization'),
        value: '',
        configs: {
          placeholder: 'Select Organization',
          options: []
        }
      }
    },
    filterOptions: {
      companyFilterOptions: null,
      formFilterOptions: null,
      structureFilterOptions: null,
      // criteriaFilterOptions: null,
      levelGroupFilterOptions: null,
      orgFilterOptions: null,
      statusFilterOptions: null
    },

    // Import modal state
    importModalOpen: false,
    importFile: null,
    // currentFilter: null

    // Action modal state
    actionModalOpen: false,
    actionForm: {
      stage_id: {
        label: this.props.translate('action'),
        elementType: 'newselect',
        elementConfig: {
          placeholder: this.props.translate('select') + this.props.translate('action'),
          options: [],
          size: 'small'
        },
        value: null,
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      end_date: {
        label: this.props.translate('endDate'),
        elementType: 'datePicker',
        elementConfig: {
          size: 'small',
          inputVariant: 'outlined'
        },
        value: null,
        validation: {
          required: true
        },
        valid: true,
        touched: false,
        error: null,
        hidden: true
      },
      remark: {
        label: this.props.translate('remark'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('remark'),
          multiline: true,
          size: 'small'
        },
        value: '',
        validation: {},
        valid: true,
        touched: false,
        error: null
      }
    },
    toStageList: null
  }

  componentDidMount() {
    this.props.fetchAppraisalTypes()

    const filters = this.props.filters || {}
    this.props.filterAssignmentRecords({
      filters,
      appraisal_type_code: this.state.appraisalTypeCode
    })
  }

  static getDerivedStateFromProps(props, state) {
    if (props.filterOptions.companyFilterOptions !== state.filterOptions.companyFilterOptions) {
      const companyFilter = state.filterControls.company_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.companyFilterOptions,
        companyFilter,
        'company_id',
        'company_id',
        { name: 'company_name', code: 'company_code' },
        'Select company'
      )

      const options = updatedFilterItem.configs?.options
      let value = options[0] || null

      updatedFilterItem = { ...updatedFilterItem, value }

      if (value) {
        const payload = {
          appraisal_type_id: props.appraisalType.appraisal_type_id,
          company_id: value.value
        }

        props.fetchFormOptions(payload)
        props.fetchStructureOptions(payload)
        props.fetchLevelGroupOptions(payload)
        props.fetchOrgOptions(payload)
        props.fetchStatusOptions(payload)
      }

      return {
        filterControls: updateObject(state.filterControls, { company_id: updatedFilterItem }),
        filterOptions: {
          ...state.filterOptions,
          companyFilterOptions: props.filterOptions.companyFilterOptions
        }
      }
    }
    if (props.filterOptions.formFilterOptions !== state.filterOptions.formFilterOptions) {
      const formFilter = state.filterControls.form_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.formFilterOptions,
        formFilter,
        'form_id',
        'form_id',
        'form_name',
        'Select Form'
      )
      const formItem = state.copyForm.form_id
      const updatedCopyFormItem = updateFormOptions(
        props.filterOptions.formFilterOptions,
        formItem,
        'form_id',
        'form_id',
        'form_name',
        'Select Form'
      )

      const options = updatedFilterItem.configs?.options
      const value = options[0] || null

      updatedFilterItem = { ...updatedFilterItem, value }

      return {
        filterControls: updateObject(state.filterControls, { form_id: updatedFilterItem }),
        copyForm: updateObject(state.copyForm, { form_id: updatedCopyFormItem }),
        filterOptions: {
          ...state.filterOptions,
          formFilterOptions: props.filterOptions.formFilterOptions
        }
      }
    }
    if (
      props.filterOptions.levelGroupFilterOptions !== state.filterOptions.levelGroupFilterOptions
    ) {
      const levelGroupFilter = state.filterControls.level_group_id
      const updatedFilterItem = updateFilterOptions(
        props.filterOptions.levelGroupFilterOptions,
        levelGroupFilter,
        'level_group_id',
        'level_group_id',
        'level_group_name',
        'Select level'
      )
      const formItem = state.copyForm.level_group_id
      const updatedCopyFormItem = updateFormOptions(
        props.filterOptions.levelGroupFilterOptions,
        formItem,
        'level_group_id',
        'level_group_id',
        'level_group_name',
        'Select Level'
      )
      return {
        filterControls: updateObject(state.filterControls, { level_group_id: updatedFilterItem }),
        copyForm: updateObject(state.copyForm, { level_group_id: updatedCopyFormItem }),
        filterOptions: {
          ...state.filterOptions,
          levelGroupFilterOptions: props.filterOptions.levelGroupFilterOptions
        }
      }
    }
    if (props.filterOptions.structureFilterOptions !== state.filterOptions.structureFilterOptions) {
      const structureFilter = state.filterControls.structure_id
      const updatedFilterItem = updateFilterOptions(
        props.filterOptions.structureFilterOptions,
        structureFilter,
        'structure_id',
        'structure_id',
        'structure_name',
        'Select structure'
      )
      return {
        filterControls: updateObject(state.filterControls, { structure_id: updatedFilterItem }),
        filterOptions: updateObject(state.filterOptions, {
          structureFilterOptions: props.filterOptions.structureFilterOptions
        })
      }
    }
    if (props.filterOptions.orgFilterOptions !== state.filterOptions.orgFilterOptions) {
      const orgFilter = state.filterControls.org_id
      const updatedFilterItem = updateFilterOptions(
        props.filterOptions.orgFilterOptions,
        orgFilter,
        'org_id',
        'org_id',
        { code: 'org_code', name: 'org_name' },
        'Select Organization'
      )
      const formItem = state.copyForm.orgs
      const updatedCopyFormItem = updateFormOptions(
        props.filterOptions.orgFilterOptions,
        formItem,
        'org_id',
        'org_id',
        { code: 'org_code', name: 'org_name' },
        'Select Organization'
      )
      return {
        filterControls: updateObject(state.filterControls, {
          org_id: updatedFilterItem
        }),
        copyForm: updateObject(state.copyForm, { orgs: updatedCopyFormItem }),
        filterOptions: {
          ...state.filterOptions,
          orgFilterOptions: props.filterOptions.orgFilterOptions
        }
      }
    }
    if (props.filterOptions.statusFilterOptions !== state.filterOptions.statusFilterOptions) {
      const statusFilter = state.filterControls.status_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.statusFilterOptions,
        statusFilter,
        'status_id',
        'status_id',
        'status_name',
        'Select status'
      )

      const levelGroupFilter = state.filterControls.level_group_id
      const updatedLevelGroupFilterItem = {
        ...levelGroupFilter,
        required: updatedFilterItem.value?.value === 'unassigned'
      }

      return {
        filterControls: updateObject(state.filterControls, {
          status_id: updatedFilterItem,
          level_group_id: updatedLevelGroupFilterItem
        }),
        filterOptions: {
          ...state.filterOptions,
          statusFilterOptions: props.filterOptions.statusFilterOptions
        }
      }
    }
    if (props.toStageList !== state.toStageList) {
      const toStage = state.actionForm.stage_id
      let updatedFilterItem = updateFormOptions(
        props.toStageList,
        toStage,
        'stage_id',
        'stage_id',
        'status_name',
        'Select status'
      )

      return {
        ...state,
        actionForm: updateObject(state.actionForm, { stage_id: updatedFilterItem }),
        toStageList: props.toStageList
      }
    }
    return null
  }

  componentDidUpdate(prevProps) {
    if (prevProps.imported !== this.props.imported && this.props.imported) {
      this.closeImportModal()
    }
    if (prevProps.appraisalType !== this.props.appraisalType) {
      this.props.fetchFilterOptions({
        appraisal_type_id: this.props.appraisalType?.appraisal_type_id
      })
    }
    if (
      prevProps.bulkUpdateSuccess !== this.props.bulkUpdateSuccess &&
      this.props.bulkUpdateSuccess
    ) {
      this.closeActionModal(true)
    }
  }

  // Clean state
  componentWillUnmount() {
    // this.clearFilter()
    this.clearCopyForm()
    this.clearState()
    this.clearSelectedRecords()
    this.props.clearRecords()
  }

  clearFilter = () => {
    const clearedFilter = clearFilterOptionValues(this.state.filterControls)
    this.setState({
      filterControls: clearedFilter
    })
  }

  clearCopyForm = () => {
    const clearCopyForm = clearInputForm(this.state.copyForm)
    this.setState({
      copyForm: clearCopyForm
    })
  }

  clearState = () => {
    this.setState({
      copyResultId: null,
      deleteOrgId: null
    })
  }

  clearSelectedRecords = () => {
    this.setState({
      selectedOrgs: [],
      selectedResults: []
    })
  }

  // records actions
  updateSelectedOrgs = (orgId, resultId) => {
    const selectedList = this.state.selectedOrgs
    const selectedResults = this.state.selectedResults
    let updatedList = []
    let updatedResultList = []

    if (selectedList.includes(orgId) || selectedResults.includes(resultId)) {
      updatedList = selectedList.filter(item => item !== orgId)
      updatedResultList = selectedResults.filter(item => item !== resultId)
    } else {
      updatedList = [...selectedList, orgId]
      if (resultId !== 0) {
        updatedResultList = [...selectedResults, resultId]
      }
    }

    this.setState({
      selectedOrgs: updatedList,
      selectedResults: updatedResultList
    })
  }

  // Copy Modal
  openCopyModal = resultId => {
    this.setState({
      copyResultId: resultId,
      copyModalOpen: true
    })
  }

  copyInputChangedHandler = (itemKey, event) => {
    const forms = { ...this.state.copyForm }
    const targetItem = forms[itemKey]
    let value = ''

    if (['newselect', 'newmultiSelect'].includes(targetItem.elementType)) {
      value = event
    }

    const { isValid, error } = checkValidity(value, targetItem.validation, targetItem.label)

    const updatedItem = { ...targetItem, value: value, valid: isValid, error, touched: true }
    const updatedForm = updateObject(forms, { [itemKey]: updatedItem })

    this.setState({
      copyForm: updatedForm
    })
  }

  copyAssignment = () => {
    const sourceResultId = this.state.copyResultId
    const formValues = extractFilterOptions(this.state.copyForm)
    const filter = extractFilterOptions(this.state.filterControls)

    this.props.copyAssignment(
      {
        ...formValues,
        result_id: sourceResultId
      },
      filter
    )
    this.closeCopyModal(true)
  }

  closeCopyModal = submitted => {
    if (submitted) {
      this.setState({
        copyResultId: null,
        copyModalOpen: false
      })
      this.clearCopyForm()
    }
  }

  // Confirmation Modal
  openConfirmationModal = resultId => {
    this.setState({
      deleteOrgId: resultId,
      confirmationModalOpen: true
    })
  }

  deleteRecord = () => {
    const pageOptions = {
      perPage: this.props.pagination.perPage,
      page: this.props.pagination.currentPage
    }
    const filters = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.deleteAssignment(this.state.deleteOrgId, filters, 'corporate')
    this.closeConfirmationModal()
  }

  closeConfirmationModal = () => {
    this.setState({
      deleteOrgId: null,
      confirmationModalOpen: false
    })
  }

  // Filter Actions
  pageChangeHandler = (e, page) => {
    const pageOptions = {
      perPage: this.props.pagination.perPage,
      page: page
    }
    const filters = extractFilterOptions(this.state.filterControls, pageOptions)

    this.props.filterAssignmentRecords({
      ...filters,
      appraisal_type_code: this.state.appraisalTypeCode
    })
  }

  perPageChangeHandler = perPage => {
    const pageOptions = {
      perPage: perPage,
      page: this.props.pagination.currentPage
    }
    const filters = extractFilterOptions(this.state.filterControls, pageOptions)

    this.props.filterAssignmentRecords({
      ...filters,
      appraisal_type_code: this.state.appraisalTypeCode
    })
  }

  openFilterModal = () => {
    this.setState({
      filterModalOpen: true
    })
  }

  filterChangedHandler = (itemKey, event) => {
    let value = event
    const filterControls = { ...this.state.filterControls }
    const updatedItem = { ...filterControls[itemKey], value }
    let updatedFilterControls = updateObject(filterControls, { [itemKey]: updatedItem })
    const appraisalTypeId = this.props.appraisalType.appraisal_type_id
    const filterOptions = extractFilterOptions(updatedFilterControls, {
      appraisal_type_id: appraisalTypeId
    })

    if (itemKey === 'company_id') {
      this.props.fetchFormOptions(filterOptions)
      this.props.fetchStructureOptions(filterOptions)
      this.props.fetchLevelGroupOptions(filterOptions)
      this.props.fetchOrgOptions(filterOptions)
      this.props.fetchStatusOptions(filterOptions)
    } else if (itemKey === 'structure_id') {
      this.props.fetchLevelGroupOptions(filterOptions)
      this.props.fetchStatusOptions(filterOptions)
    } else if (itemKey === 'level_group_id') {
      this.props.fetchOrgOptions(filterOptions)
    } else if (itemKey === 'status_id') {
      this.props.fetchLevelGroupOptions(filterOptions)
      updatedFilterControls = updateObject(updatedFilterControls, {
        level_group_id: {
          ...updatedFilterControls.level_group_id,
          required: value?.value === 'unassigned'
        }
      })
      updatedFilterControls = updateObject(updatedFilterControls, {
        org_id: {
          ...updatedFilterControls.org_id,
          required: value?.value === 'unassigned'
        }
      })
    }

    this.setState({
      filterControls: updatedFilterControls
    })
  }

  closeFilterModal = filtered => {
    this.setState({
      filterModalOpen: false
    })
    if (!filtered) {
      this.clearFilter()
    } else {
      this.clearSelectedRecords()
    }
  }

  filterRecords = () => {
    const pageOptions = {
      perPage: this.props.pagination.perPage,
      page: this.props.pagination.currentPage
    }
    const filters = extractFilterOptions(this.state.filterControls, {
      ...pageOptions,
      appraisal_type_code: this.state.appraisalTypeCode
    })

    // this.setState({
    //   currentFilter: filters
    // })
    this.props.filterAssignmentRecords(filters)
    this.closeFilterModal(true)
  }

  startAssignment = () => {
    const selectedOrgIds = this.state.selectedOrgs
    if (selectedOrgIds.length < 1) {
      this.props.fireAlert({
        message: 'Please select organizations',
        options: {
          variant: 'error'
        }
      })
    } else {
      this.props.setAssignmentData({
        company_id:
          this.state.filterControls.company_id.value?.value || this.props.filters?.company_id,
        appraisal_type_id: this.props.appraisalType?.appraisal_type_id
      })
      this.props.setAssignTarget(selectedOrgIds, this.props.appraisalType)
      this.props.history.push('items')
    }
  }

  openImportModal = () => {
    this.setState({
      importModalOpen: true
    })
  }

  closeImportModal = () => {
    this.setState({
      importModalOpen: false,
      importFile: null
    })
  }

  importFileChangedHandler = event => {
    const file = event.target.files[0]
    this.setState({
      importFile: file
    })
  }

  importSubmittedHandler = () => {
    const filters = extractFilterOptions(this.state.filterControls)

    this.props.importAssignmentData(this.state.importFile, filters, this.props.appraisalType)
    // this.closeImportModal()
  }

  exportAssignmentData = () => {
    const selectedOrgIds = this.state.selectedOrgs
    const filters = extractFilterOptions(this.state.filterControls)

    this.props.setAssignmentData({
      company_id: filters?.company_id || this.props.filters?.company_id || null,
      appraisal_type_id: this.props.appraisalType?.appraisal_type_id || null
    })
    this.props.setSelectAction('export')
    this.props.setAssignTarget(selectedOrgIds, this.props.appraisalType)
    this.props.history.push('items')

    // this.props.exportAssignmentData(filters)
  }

  selectAllClickedHandler = () => {
    this.setState(prevState => {
      let selectedOrgs = prevState.selectedOrgs
      let selectedResults = prevState.selectedResults
      if (!selectedOrgs.length) {
        selectedOrgs = this.props.records
          // .filter(item => !item.structures.every(st => st.assigned))
          .map(item => item.org_id)
        selectedResults = this.props.records
          .filter(item => item.result_id)
          .map(item => item.result_id)
      } else {
        selectedOrgs = []
        selectedResults = []
      }

      return {
        selectedOrgs,
        selectedResults
      }
    })
  }

  bulkDeleteClickedHandler = async () => {
    this.setState({
      bulkConfirmationModalOpen: true
    })
  }

  bulkDeleteConfirmedHandler = () => {
    const { selectedResults } = this.state
    if (selectedResults.length) {
      this.props.bulkDeleteAssignment(selectedResults, 'corporate')
      this.closeBulkDeleteModal()
    }
  }

  bulkDeleteCancelledHandler = () => {
    this.closeBulkDeleteModal()
  }

  closeBulkDeleteModal = () => {
    this.setState({
      bulkConfirmationModalOpen: false,
      selectedResults: [],
      selectedOrgs: []
    })
  }

  actionClickedHandler = () => {
    this.setState({
      actionModalOpen: true
    })
  }

  actionInputChangedHandler = (formKey, event) => {
    const form = { ...this.state.actionForm }
    const formItem = form[formKey]

    const updatedItem = updateFormData(formItem, event)
    let updatedForm = updateObject(form, { [formKey]: updatedItem })

    if (formKey === 'stage_id') {
      const code = event?.status_code
      const endDateForm = updatedForm.end_date
      let updatedEndDateForm = {
        ...endDateForm,
        value: moment(),
        validation: { ...endDateForm.validation, required: code === 'CLS' },
        hidden: code !== 'CLS'
      }

      updatedEndDateForm = updateFormData(updatedEndDateForm, updatedEndDateForm.value)

      updatedForm = updateObject(updatedForm, { end_date: updatedEndDateForm })
    }

    this.setState({ actionForm: updatedForm })
  }

  submitActionHandler = () => {
    const actionFormData = extractFormData(this.state.actionForm)
    const requestData = {
      ...actionFormData,
      status_name: this.state.actionForm.stage_id.value?.label,
      structure_id: this.props.filters?.structure_id,
      result_id: this.state.selectedResults,
      from_page: 'assignment'
    }
    const filterOptions = extractFilterOptions(this.state.filterControls, {
      appraisal_type_code: this.state.appraisalTypeCode
    })
    this.props.bulkUpdateAssignment(requestData, filterOptions, 'corporate')
  }

  closeActionModal = isCancel => {
    this.setState({
      actionModalOpen: false
    })

    if (isCancel) {
      this.clearActionForm()
    }
  }

  clearActionForm = () => {
    let cleared = clearInputForm({ ...this.state.actionForm })
    cleared = updateObject(cleared, { end_date: { ...cleared.end_date, hidden: true } })
    this.clearSelectedRecords()
    this.setState({ actionForm: cleared })
  }

  render() {
    return (
      <Aux>
        <ActionModal
          open={this.state.actionModalOpen}
          cancelled={this.closeActionModal}
          submitted={this.submitActionHandler}
          actionForm={this.state.actionForm}
          actionInputChanged={this.actionInputChangedHandler}
        />
        <ImportModal
          open={this.state.importModalOpen}
          cancelled={this.closeImportModal}
          fileChanged={this.importFileChangedHandler}
          fileSubmit={this.importSubmittedHandler}
          selectedFile={this.state.importFile}
          title={this.props.translate('assignment')}
          loading={this.props.importLoading}
        />
        <ConfirmationModal
          open={this.state.confirmationModalOpen}
          cancelled={this.closeConfirmationModal}
          confirmed={this.deleteRecord}
          promptText={this.props.translate('confirmDel')}
        />
        <ConfirmationModal
          open={this.state.bulkConfirmationModalOpen}
          cancelled={this.bulkDeleteCancelledHandler}
          confirmed={this.bulkDeleteConfirmedHandler}
          promptText={this.props.translate('confirmDel')}
        />
        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={this.filterRecords}
          filterChanged={(itemKey, e) => this.filterChangedHandler(itemKey, e)}
          filterControls={this.state.filterControls}
          loadingQueue={this.props.filterLoadingQueue}
        />
        <CopyModal
          open={this.state.copyModalOpen}
          cancelled={this.closeCopyModal}
          copyInputChanged={(itemKey, e) => this.copyInputChangedHandler(itemKey, e)}
          copyForm={this.state.copyForm}
          copySaved={this.copyAssignment}
        />
        <Alert />
        <CorporateContent
          companyName={this.state.filterControls.company_id.value?.label}
          pagePermission={this.props.pagePermission}
          copyButtonClicked={this.openCopyModal}
          deleteButtonClicked={this.openConfirmationModal}
          orgCheckboxChanged={this.updateSelectedOrgs}
          assignButtonDisabled={this.props.filters?.status_id !== 'unassigned'}
          assignButtonClicked={this.startAssignment}
          orgRecords={this.props.records}
          pagination={this.props.pagination}
          pageChanged={this.pageChangeHandler}
          perPageChanged={this.perPageChangeHandler}
          filterButtonClicked={this.openFilterModal}
          exportButtonDisabled={
            this.state.selectedOrgs.length < 1 || this.props.filters?.status_id !== 'unassigned'
          }
          exportButtonClicked={this.exportAssignmentData}
          importButtonClicked={this.openImportModal}
          selectedOrgs={this.state.selectedOrgs}
          selectedResults={this.state.selectedResults}
          selectAllClicked={this.selectAllClickedHandler}
          selectAllDisabled={!this.props.filters || !this.props.records.length}
          bulkDeleteButtonClicked={this.bulkDeleteClickedHandler}
          bulkDeleteButtonDisabled={
            this.state.selectedResults.length < 1 || this.props.filters?.status_id === 'unassigned'
          }
          filtered={!!this.props.filters}
          pageLoading={this.props.pageLoading}
          filters={this.props.filters}
          actionClicked={this.actionClickedHandler}
          actionDisabled={
            !this.props.filters?.structure_id ||
            !this.props.filters?.status_id ||
            this.props.filters?.status_id === 'unassigned' ||
            !this.state.selectedResults.length
          }
        />
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  const appraisalType = state.corporateAssignment.appraisalTypes.find(item => {
    return item.appraisal_type_code === 'APT01'
  })

  return {
    records: state.corporateAssignment.records,
    pagination: state.corporateAssignment.pagination,
    appraisalType: appraisalType,
    // filtered: state.corporateAssignment.filtered,
    imported: state.corporateAssignment.imported,
    filters: state.assignmentFlow.filter,
    filterLoadingQueue: state.individualAssignment.filterLoadingQueue,
    pageLoading:
      state.corporateAssignment.recordsLoading ||
      state.corporateAssignment.appraisalTypes.length === 0,
    filterOptions: {
      companyFilterOptions: state.corporateAssignment.filterCompanies,
      formFilterOptions: state.corporateAssignment.filterForms,
      structureFilterOptions: state.corporateAssignment.filterStructure,
      orgFilterOptions: state.corporateAssignment.filterOrgs,
      levelGroupFilterOptions: state.corporateAssignment.filterOrgLevelGroups,
      statusFilterOptions: state.corporateAssignment.filterStatus
    },
    importLoading: state.corporateAssignment.importLoading,
    toStageList: state.corporateAssignment.toStageList,
    bulkUpdateSuccess: state.corporateAssignment.bulkUpdateSuccess
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchAppraisalTypes: () => {
      dispatch(actions.fetchAppraisalTypeOptions())
    },
    fetchFilterOptions: filterOptions => {
      dispatch(actions.fetchCompanyOptionsForAppraisal(filterOptions))
    },
    fetchFormOptions: filterOptions => {
      dispatch(actions.fetchFormOptions(filterOptions))
    },
    fetchStructureOptions: filterOptions => {
      dispatch(actions.fetchStructureOptionsForAppraisal(filterOptions))
    },
    fetchLevelGroupOptions: filterOptions => {
      dispatch(actions.fetchLevelGroupOptionsForAppraisal(filterOptions))
    },
    fetchOrgOptions: filterOptions => {
      dispatch(actions.fetchOrganizationOptionsForAppraisal(filterOptions))
    },
    fetchStatusOptions: filterOptions =>
      dispatch(actions.fetchAssignmentStatusOptionsForAppraisal(filterOptions)),
    filterAssignmentRecords: filterOptions => {
      dispatch(actions.fetchAssignmentData(filterOptions, 'corporate'))
    },
    setAssignTarget: (orgIds, appraisalType) => {
      dispatch(actions.setAssignTarget(orgIds, appraisalType))
    },
    fireAlert: alertOption => {
      dispatch(actions.enqueueSnackbar(alertOption))
    },
    importAssignmentData: (importFile, filters, appraisalType) => {
      dispatch(actions.importAssignmentData(importFile, filters, appraisalType))
    },
    setSelectAction: action => {
      dispatch(actions.setAssignmentAction(action))
    },
    setAssignmentData: data => dispatch(actions.setAssignmentData(data)),
    deleteAssignment: (resultId, filterOptions, appraisalType) =>
      dispatch(actions.deleteAssignment(resultId, filterOptions, appraisalType)),
    copyAssignment: (data, filter) => dispatch(actions.copyAssignment(data, 'corporate')),
    clearRecords: () => {
      dispatch(actions.clearFilteredAssignmentRecords())
    },
    bulkDeleteAssignment: (orgs, appraisalType) =>
      dispatch(actions.bulkDeleteAssignment(orgs, appraisalType)),
    bulkUpdateAssignment: (resultIds, filterOptions, appraisalType) => {
      dispatch(actions.bulkUpdateAssignment(resultIds, filterOptions, appraisalType))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(Corporate))
